/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ListChatActivities_Query = {
    readonly viewer: {
        readonly roles: ReadonlyArray<string | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ToolbarChatActivities_Query" | "ListChatActivitiesPagination_Query">;
    readonly " $refType": "ListChatActivities_Query";
};
export type ListChatActivities_Query$data = ListChatActivities_Query;
export type ListChatActivities_Query$key = {
    readonly " $data"?: ListChatActivities_Query$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListChatActivities_Query">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterCount"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "includeAssignee"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListChatActivities_Query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roles",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filterCount"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ToolbarChatActivities_Query"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        },
        {
          "kind": "Variable",
          "name": "includeAssignee",
          "variableName": "includeAssignee"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ListChatActivitiesPagination_Query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = '9d52522d39bc25cbcb56c6294ccd5005';
export default node;
